import { GalleryProduct } from '../typings';

type GetPricingDetailsParameters = {
  isBusiness: boolean;
} & Pick<
  GalleryProduct,
  | 'priceType'
  | 'basePrice'
  | 'basePriceExcludingTax'
  | 'effectivePrice'
  | 'effectivePriceExcludingTax'
>;

export function getPricingDetails({
  priceType,
  basePrice,
  basePriceExcludingTax,
  effectivePrice,
  effectivePriceExcludingTax,
  isBusiness,
}: GetPricingDetailsParameters) {
  const isMonthlyPayment = priceType?.toLocaleLowerCase() === 'recurring';
  const hasAssociatedPriceRule = isMonthlyPayment && effectivePrice;
  const consumerPrice = hasAssociatedPriceRule ? effectivePrice : basePrice;
  const businessPrice = hasAssociatedPriceRule
    ? effectivePriceExcludingTax
    : basePriceExcludingTax;

  return {
    priceValue: isBusiness ? businessPrice : consumerPrice,
    pricePeriod: isMonthlyPayment ? 'month' : '',
    isGstExcl: isBusiness,
  };
}

type GetStartingTextParameters = {
  isDeferrable: boolean;
  priceType: GalleryProduct['priceType'];
};
export function getStartingText({
  isDeferrable,
  priceType,
}: GetStartingTextParameters): string {
  if (isDeferrable && priceType !== 'Onetime') {
    return 'From';
  }
  return '';
}
